import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class RouteErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("RouteErrorBoundary caught:", error, info);
  }

  private reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex-1 flex items-center justify-center p-8"
          role="alert"
        >
          <div
            className="max-w-md text-center"
            style={{ color: "var(--text-primary)" }}
          >
            <h2 className="text-lg font-semibold mb-2">
              This module failed to load
            </h2>
            <p
              className="text-sm mb-4"
              style={{ color: "var(--text-muted)" }}
            >
              {this.state.error?.message ||
                "An unexpected error occurred. Try refreshing or navigating to another module."}
            </p>
            <button
              onClick={this.reset}
              className="px-4 py-2 rounded text-sm"
              style={{ background: "var(--accent)", color: "white" }}
            >
              Try again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
